import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getLocaleFromLanguageCode } from "@/features/i18n/i18n";

interface UseDateFormatOptions {
  dateFormatOptions?: Intl.DateTimeFormatOptions;
  nullishValue?: string;
}

export function useDateFormat(options: UseDateFormatOptions = {}) {
  const { i18n } = useTranslation();
  const { dateFormatOptions, nullishValue = "–" } = options;

  const locale = useMemo(
    () => getLocaleFromLanguageCode(i18n.language),
    [i18n.language],
  );

  const dateFormat = useMemo(
    () => (value: string | number | Date | null | undefined) => {
      if (value === null || value === undefined) {
        return nullishValue;
      }

      try {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return nullishValue;
        }
        return new Intl.DateTimeFormat(locale, dateFormatOptions).format(date);
      } catch {
        return nullishValue;
      }
    },
    [locale, dateFormatOptions, nullishValue],
  );

  return dateFormat;
}
